import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const iconArrowRight: React.FC<SvgIconProps> = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 59 51" // שמירה על הערכים המקוריים של viewBox
    style={{ width: 52, height: 40, cursor: 'pointer', transition: 'all 0.2s ease-in-out' }} // שמירה על הערכים המקוריים של width ו-height
    sx={{
      '&:hover': {
        transform: 'scale(1.1)', // הנפשה בהובר - הגדלה של 10%
        filter: 'drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.3))',
      },
    }}
  >
    <path d="M57.7686 27.9873L36.6748 49.0811C36.0144 49.7415 35.1186 50.1125 34.1846 50.1125C33.2506 50.1125 32.3548 49.7415 31.6943 49.0811C31.0339 48.4206 30.6628 47.5248 30.6628 46.5908C30.6628 45.6568 31.0339 44.761 31.6943 44.1006L46.7852 29.0156H3.71875C2.78635 29.0156 1.89214 28.6452 1.23283 27.9859C0.57352 27.3266 0.203125 26.4324 0.203125 25.5C0.203125 24.5676 0.57352 23.6734 1.23283 23.0141C1.89214 22.3548 2.78635 21.9844 3.71875 21.9844H46.7852L31.7002 6.89062C31.0397 6.23017 30.6687 5.3344 30.6687 4.40038C30.6687 3.46637 31.0397 2.5706 31.7002 1.91015C32.3606 1.2497 33.2564 0.878662 34.1904 0.878662C35.1244 0.878662 36.0202 1.2497 36.6807 1.91015L57.7744 23.0039C58.1022 23.331 58.3622 23.7195 58.5394 24.1474C58.7166 24.5752 58.8075 25.0338 58.807 25.4968C58.8064 25.9599 58.7144 26.4183 58.5362 26.8456C58.358 27.273 58.0971 27.661 57.7686 27.9873Z" fill="currentColor" />
  </SvgIcon>
);

export default iconArrowRight;
